// extracted by mini-css-extract-plugin
module.exports = {"main-container":"Cart_main-container__R4oUJ","aside":"Cart_aside__13BZB","main":"Cart_main__3jiF-"};